import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Återanvändbar SEO-komponent för publika sidor på Bygglovskompassen.
 * Sätter unik <title>, meta-description, canonical, Open Graph
 * och strukturerad data (JSON-LD) för Google & AI-crawlers.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
  keywords,
  noindex = false,
  jsonLd,
}) {
  const site = "https://bygglovkollen.se";
  const fullTitle = title
    ? `${title} | Bygglovskompassen`
    : "Bygglovskompassen – Gratis hjälp med bygglovsansökan";
  const desc =
    description ||
    "Bygglovskompassen hjälper svenska medborgare att förstå, planera och sammanställa bygglovsansökan – helt kostnadsfritt. AI-rådgivning, regelmotor enligt PBL och färdig ansökan-PDF att skicka till kommunen.";
  const canonical = `${site}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content="Bygglovskompassen" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="sv_SE" />
      {image && <meta property="og:image" content={image} />}
      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
